import * as React from "react";
const SvgFiRrPhoneRotary = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-phone-rotary_svg__a)">
      <path
        fill="#062147"
        d="M12 10c-2.757 0-5 2.243-5 5s2.243 5 5 5 5-2.243 5-5-2.243-5-5-5m0 8c-1.654 0-3-1.346-3-3s1.346-3 3-3 3 1.346 3 3-1.346 3-3 3m8.646-7.04C22.526 10.76 24 9.182 24 7.251c0-1.415-.564-2.76-1.593-3.789-4.572-4.572-16.244-4.57-20.814 0C.564 4.492 0 5.836 0 7.25c0 1.932 1.475 3.51 3.354 3.71l-2.06 3.863A11.04 11.04 0 0 0 0 20c0 2.206 1.794 4 4 4h16c2.206 0 4-1.794 4-4 0-1.799-.447-3.589-1.294-5.177zM2 7.25c0-.88.356-1.724 1.007-2.374 3.867-3.865 14.121-3.865 17.986 0 .65.65 1.008 1.493 1.007 2.374C22 8.215 21.215 9 20.25 9h-.684l-.777-1.295a3.93 3.93 0 0 0-1.729-1.563c-1.13-.52-2.925-1.14-5.06-1.14s-3.93.62-5.059 1.14c-.717.33-1.315.87-1.73 1.563L4.434 9H3.75C2.785 9 2 8.215 2 7.25M20 22H4c-1.103 0-2-.897-2-2 0-1.472.366-2.937 1.06-4.235l2.818-5.284 1.048-1.748c.208-.346.502-.614.853-.775C8.726 7.521 10.228 7 12.001 7s3.274.521 4.223.958c.35.161.644.43.852.775l1.048 1.748 2.818 5.284A9 9 0 0 1 22.002 20c0 1.103-.897 2-2 2z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-phone-rotary_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrPhoneRotary;
